import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch, useMutation } from '../api';

type GetApplication =
  ApiClient['v1']['workspaces'][':workspaceId']['applications'][':applicationId']['$get'];
export type ApplicationDetailedResponse = InferResponseType<GetApplication, 200>;

type UpdateApplication =
  ApiClient['v1']['workspaces'][':workspaceId']['applications'][':applicationId']['$put'];
export type UpdateApplicationRequest = InferRequestType<UpdateApplication>['json'];
type UpdateApplicationResponse = InferResponseType<UpdateApplication, 200>;

export function useApplication(workspaceId: number, applicationId: number) {
  return useFetch<ApplicationDetailedResponse>(
    `workspaces/${workspaceId}/applications/${applicationId}`,
    (client) =>
      client.v1.workspaces[':workspaceId'].applications[':applicationId'].$get({
        param: { workspaceId: workspaceId.toString(), applicationId: applicationId.toString() },
      })
  );
}

export function useUpdateApplication(workspaceId: number, applicationId: number) {
  return useMutation<UpdateApplicationResponse, UpdateApplicationRequest>(
    `workspaces/${workspaceId}/applications/${applicationId}`,
    (client, updates) =>
      client.v1.workspaces[':workspaceId'].applications[':applicationId'].$put({
        param: { workspaceId: workspaceId.toString(), applicationId: applicationId.toString() },
        json: updates,
      })
  );
}
